import { render, staticRenderFns } from "./SalabamBooking.vue?vue&type=template&id=1bdccb90&scoped=true"
import script from "./SalabamBooking.vue?vue&type=script&lang=js"
export * from "./SalabamBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdccb90",
  null
  
)

export default component.exports